import { blocks } from '@yola/ws-sdk';

const MEDIA_WIDGETS = [
  'widget-embed',
  'widget-gallery',
  'widget-image',
  'widget-video',
  'widget-music',
];

const isMediaWidget = (element) => {
  const blockId = blocks.accessors.getBlockIdByElement(element);
  return MEDIA_WIDGETS.includes(blockId);
};

export default isMediaWidget;
